// extracted by mini-css-extract-plugin
export default {"float":"social-section-overflow-SectionOverflowMenu__float--3mJ5J"};